<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>


<div class="grid" *ngIf="EstCharge()">
    <div class="col-12">

        <p-card>
            <p-table #dt [value]="series"  dataKey="serieId" autoLayout="true" tableStyleClass="tableNormale"
                
                [rowHover]="true" [filterDelay]="0"
                [globalFilterFields]="['dateDebut','dateFin','nombre']">
                <ng-template pTemplate="caption">
                    <div class="flex align-content-center justify-content-between">
                        <div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Recherche..." />
                            </span>
                        </div>
                        <h5 class="titreTableau m-0">Séries de soumission</h5>
                        <div>

                            <p-multiSelect disabled="true" [style]="{minWidth: '200px'}" placeholder="Colonnes..."></p-multiSelect>
                        </div>
                    </div>
                </ng-template>
               
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="dateDebut">
                            <div class="flex justify-content-between align-items-center">
                                Date de début
                                <p-sortIcon field="dateDebut"></p-sortIcon>
                                <p-columnFilter type="date" field="dateDebut" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="dateFin">
                            <div class="flex justify-content-between align-items-center">
                                Date de fin
                                <p-sortIcon field="dateFin"></p-sortIcon>
                                <p-columnFilter type="date" field="dateFin" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nombre">
                            <div class="flex justify-content-between align-items-center">
                                Nombre de soumissions
                                <p-sortIcon field="nombre"></p-sortIcon>
                                <p-columnFilter type="text" field="nombre" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                    
                        <th style="min-width: 4rem;"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-serie let-columns="columns">
                    <tr>
                        
                        <td>{{serie.dateDebut | date:'yyyy-MM-dd'}}</td>
                        <td>{{serie.dateFin | date:'yyyy-MM-dd'}}</td>
                        <td>{{serie.nombre}}</td>
                        
                        <td class="celluleTableau">
                            <div class="flex">
                                <button pButton pRipple icon="pi pi-check" class="p-button-success mr-2 boutonGrille"
                                    (click)="creerSerie(serie)"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4">Aucune série de soumission disponible.</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>


</div>